import {
  AssignLicensePage,
  AuthorizePage,
  ConfirmDeletePage,
  ConfirmForgotPasswordPage,
  ConfirmSignUpPage,
  DeviceSettings,
  HelpPage,
  LoginPage,
  MyDevicesPage,
  OfflinePage,
  PasswordRecoveryPage,
  SignUpPage,
  UserSettingsPage,
  VoiceConfigPage,
  VoiceControlEditPage,
  VoiceControlsPageMobile,
} from "./pages";
import { Footer, Header, PrivateRoute } from "./components";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { CSS_SIZE_SM } from "./constants/constants";
import { IntlProvider } from "react-intl";
import Media from "react-media";
import cn from "classnames";
import { getLocale } from "./redux/settings-slice";
import { getLocaleMessages } from "./i18n";
import { oemValues } from "./constants/oem";
import styles from "./App.module.scss";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const DEFUAULT_LOCALE = "en";

function isPublicRoute(route) {
  return [
    "/login",
    "/signup",
    "/terms-and-conditions",
    "/confirm_signup",
    "/password-recovery",
    "/help",
    "/authorize",
    "/service-activation",
  ].includes(route);
}

function App() {
  const currentLocale = useSelector(getLocale);
  const messages = getLocaleMessages(currentLocale);
  const location = useLocation();
  const isPublic = isPublicRoute(location.pathname);

  useEffect(() => {
    if (isPublic) {
      document.body.classList.remove(styles.privateBackground);
    } else {
      document.body.classList.add(styles.privateBackground);
    }
  }, [isPublic]);

  return (
    <IntlProvider
      locale={currentLocale}
      defaultLocale={DEFUAULT_LOCALE}
      messages={messages}
    >
      <Media query={`(max-width: ${CSS_SIZE_SM}px)`}>
        {(isMobile) => (
          <Switch>
            <Route path="/offline">
              <OfflinePage />
            </Route>
            <Route path="/">
              <div
                className={cn(
                  styles.wrapper,
                  !isPublic && styles.privateBackground
                )}
              >
                <div className={styles.container}>
                  <Header></Header>
                  <div className={styles.content}>
                    <Switch>
                      <Route path="/login">
                        <LoginPage />
                      </Route>
                      <Route path="/(signup|terms-and-conditions)/">
                        <SignUpPage />
                      </Route>
                      <Route path="/password-recovery">
                        <PasswordRecoveryPage />
                      </Route>
                      <Route path="/confirm-signup">
                        <ConfirmSignUpPage />
                      </Route>
                      <Route path="/confirm-forgot-password">
                        <ConfirmForgotPasswordPage />
                      </Route>
                      <Route path="/confirm-delete-user">
                        <ConfirmDeletePage />
                      </Route>
                      <Route path="/help">
                        <HelpPage />
                      </Route>
                      {oemValues.voiceControl && [
                        <Route path="/authorize">
                          <AuthorizePage />
                        </Route>,
                        <Route path="/service-activation">
                          <AssignLicensePage />
                        </Route>,
                      ]}
                      <PrivateRoute exact path="/" component={MyDevicesPage} />
                      <PrivateRoute
                        path="/settings"
                        component={UserSettingsPage}
                      />
                      <PrivateRoute
                        path="/device-settings/:id"
                        component={DeviceSettings}
                      />
                      <PrivateRoute
                        exact
                        path="/voice"
                        component={VoiceConfigPage}
                        isVoiceRoute={true}
                      />
                      <PrivateRoute
                        path={[
                          "/voice/:cloudId/controls/new",
                          "/voice/:cloudId/controls/:controlId",
                        ]}
                        component={VoiceControlEditPage}
                        isVoiceRoute={true}
                      />
                      {isMobile && (
                        <PrivateRoute
                          path="/voice/:cloudId/controls"
                          component={VoiceControlsPageMobile}
                          isVoiceRoute={true}
                        />
                      )}
                      {/* Some pages redirect to /voice/:cloudId/controls,
                          which only exists on mobile. This route makes sure
                          that this will redirect to /voice on desktop.
                      */}
                      <Route path="/voice/*">
                        <Redirect to="/voice" />
                      </Route>
                      <Route path="*">
                        <Redirect to="/" />
                      </Route>
                    </Switch>
                  </div>
                  <Footer />
                </div>
              </div>
            </Route>
          </Switch>
        )}
      </Media>
    </IntlProvider>
  );
}

export default App;
